<template>
  <div class="container">
    <div class="key-box">
      <div class="key-search clearfix">
        <span class="key-title clearfix" @click="handleSeachBlock">
          {{titletext}}
          <img :src="imgUrl" alt srcset />
        </span>
        <!-- <img class="search-icon" src="@/images/search.png" alt srcset v-show="seachIconShow" /> -->
        <span class="key-search-input">
          <form controlbox="false" action="javascript:void 0" style="height:100%">
            <input v-reset-page 
              type="search"
              placeholder="请搜索关键字"
              v-model="keyWord"
              @keyup.13="tapToSearch"
              @focus="handleFoucsClick"
              ref="searchinput"
            />
          </form>
        </span>
      </div>
      <div class="key-search-cancel clearfix" @click="handlecancelClick">取消</div>
    </div>
    <div class="search-block" v-show="isSearchBlockShow">
      <span class="arrow-top"></span>
      <ul>
        <li @click="handleSearchList(1,$event)">内容搜索</li>
        <li @click="handleSearchList(0,$event)">标题搜索</li>
      </ul>
    </div>
    <!-- 搜索列表 -->
    <div class="searchListTitle" v-if="typeIndex == 0">
      <div
        v-for="(item,index) in SearchTiyleList"
        :key="index"
        @click="handleGopageSearchDetails(item.id)"
      >{{item.title}}</div>
    </div>
    <!-- 判断展示内容搜索列表 -->
    <div v-if="typeIndex == 1">
      <div
        class="search-detail"
        v-for="(item,index) in SearchTiyleList"
        :key="index"
        @click="handleGopageSearchDetails(item.id)"
      >
        <div class="search-detail-title">{{item.title}}</div>
        <div class="search-detail-content" v-html="brightenKeyword(item.content,keyWord)"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Search, Toast } from "vant";
// 手风琴列表
import { Collapse, CollapseItem } from "vant";
import { SeacrhList } from "@/api/knowledgeBase";
export default {
  components: {
    vanSearch: Search,
    vanCollapse: Collapse,
    vanCollapseItem: CollapseItem
  },
  data() {
    return {
      activeName: "2",
      value: "1",
      isSearchBlockShow: false,
      imgUrl: require("@/images/down.png"),
      titletext: "标题搜索",
      SearchTiyleList: [],
      keyWord: "",
      typeIndex: 0
    };
  },
  mounted() {
    this.requestSeacrhList();
  },
  methods: {
    // 模块儿隐藏或者展示
    handleSeachBlock() {
      this.isSearchBlockShow = !this.isSearchBlockShow;
      if (this.isSearchBlockShow) {
        this.imgUrl = require("@/images/up.png");
      } else {
        this.imgUrl = require("@/images/down.png");
      }
    },
    // 获取焦点
    handleFoucsClick() {},
    // 操作模块的list列表
    handleSearchList(index, e) {
      this.typeIndex = index;
      if (index == 1) {
        this.imgUrl = require("@/images/down.png");
      }
      if (index == 0) {
        this.imgUrl = require("@/images/down.png");
      }
      this.titletext = e.target.innerText;
      this.isSearchBlockShow = false;
    },
    // 点击搜索的时候触发
    tapToSearch() {
      this.requestSeacrhList();
      this.$refs.searchinput.blur();
    },
    // 点击取消
    handlecancelClick() {
      this.keyWord = "";
    },
    //  搜索选项中的值高亮
    brightenKeyword(val, keyword) {
      val = val + "";
      if (val.indexOf(keyword) !== -1 && keyword !== "") {
        return val.replace(
          keyword,
          '<font color="#FF3838">' + keyword + "</font>"
        );
      } else {
        return val;
      }
    },
    // 常见问题列表
    requestSeacrhList() {
      let typeIndex = this.typeIndex;
      let keyWord = this.keyWord;
      SeacrhList({ type: typeIndex, titleOrContent: keyWord }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.SearchTiyleList = res.data;
          if (res.data.length == 0) {
            Toast("你搜索的内容不存在");
          }
        }
      });
    },
    handleGopageSearchDetails(id) {
      this.$router.push({
        path: "/basesearchdetails",
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  position: relative;
  input::-webkit-search-cancel-button {
    display: none;
  }
  .key-box {
    width: 100%;
    height: 65px;
    background-color: #ffffff;
    overflow-x: hidden;
    .key-search {
      width: 312px;
      height: 45px;
      background-color: #f6f6f6;
      border-radius: 10px;
      margin-left: 13px;
      margin-top: 10px;
      margin-bottom: 10px;
      text-align: left;
      position: relative;
      .key-title {
        display: inline-block;
        font-size: 14px;
        line-height: 35px;
        float: left;
        position: relative;
        top: 6px;
        margin-left: 10px;
        color: #333333;
        img {
          width: 10px;
          height: 6px;
          margin-left: 3px;
          margin-right: 2px;
        }
      }
      .search-icon {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-left: 5px;
      }
      .key-search-input {
        display: inline-block;
        width: 50%;
        height: 43px;
        position: relative;
        margin-top: 2px;
        margin-left: 5px;
        vertical-align: middle;
        input {
          display: inline-block;
          border: none;
          background-color: #f6f6f6;
          width: 100%;
          height: 42px;
          line-height: normal;
          padding: 5px;
          vertical-align: middle;
          font-size: 14px;
          color: #333333;
          -webkit-appearance: none; /*解决ios样式问题*/
          &::-webkit-search-cancel-button {
            display: none;
          }
        }
      }
    }
    .key-search-cancel {
      position: absolute;
      right: 10px;
      top: 28px;
      color: #008cff;
      font-size: 14px;
    }
  }
  // 标题模块
  .search-block {
    width: 80px;
    max-height: 100%;
    font-size: 14px;
    background-color: #ffffff;
    // padding: 10px;
    box-sizing: border-box;
    position: absolute;
    left: 30px;
    top: 51px;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    .arrow-top {
      display: block;
      width: 0;
      height: 0;
      border-width: 0 8px 8px;
      border-style: solid;
      border-color: transparent transparent #eeeeee; /*透明 透明  灰*/
      margin: 0 auto;
      position: absolute;
      top: -7px;
      right: 33px;
      z-index: 1;
    }
    ul {
      width: 100%;
      max-height: 100%;
      li {
        width: 100%;
        height: 30px;
        line-height: 30px;
        &:hover {
          background-color: #eaeaea;
        }
      }
    }
  }
  //搜索标题列表
  .searchListTitle {
    width: 100%;
    max-height: 100%;
    background-color: #ffffff;
    text-align: left;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 15px;
    margin-top: 10px;
    div {
      width: 100%;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #f2f2f2;
      background-color: #ffffff;
      text-align: left;
      font-size: 15px;
    }
  }
  .search-detail {
    width: 100%;
    background-color: #ffffff;
    text-align: left;
    padding: 18px 12px;
    box-sizing: border-box;
    margin-top: 10px;
    .search-detail-title {
      width: 100%;
      font-size: 14px;
      color: #333333;
    }
    .search-detail-content {
      font-size: 13px;
      color: #999999;
      line-height: 1.5;
      margin-top: 19px;
    }
  }
}
</style>
<style lang="scss">
.van-search__content {
  border-radius: 10px;
}
.van-cell__title {
  text-align: left;
}
.van-collapse-item__content {
  text-align: left;
}
</style>